import { createSlice } from "@reduxjs/toolkit";
import { HintsTypeByGet } from "Shared/Types/hints";
import { getHints } from "./HintsReducer";
import { RootState } from "Redux/store";

interface IHintsState {
  error?: string | null;
  loading: boolean;
  success?: boolean | null;
  hints: HintsTypeByGet[];
  numPage: number;
}

const initialState: IHintsState = {
  loading: false,
  error: null,
  hints: [],
  numPage: 0,
};

const hintsSlice = createSlice({
  name: "hints",
  initialState,
  reducers: {
    clear(state) {
      state.error = null;
      state.loading = false;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHints.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getHints.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.hints = action.payload as any;
      })
      .addCase(getHints.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Something went wrong";
      });
  },
});

export const selectHints = (state: RootState) => state.hints.hints;
export const selectHintsLoading = (state: RootState) => state.hints.loading;

export const { clear } = hintsSlice.actions;
export default hintsSlice;
